import { useEffect, useState } from "react";
import { GetLogCollectionListReqQuery } from "../types/logCollectionContract";
import { LogCollection } from "../types/logCollection";
import apiGetLogCollectionList from "../api/logCollection/apiGetLogCollectionList";
import { useAppContext } from "../contexts/DataContext";
import { useLoadingContext } from "../contexts/LoadingContext";
import { ErrorI } from "../types/api";

const useLogCollectionList = (query?: GetLogCollectionListReqQuery) => {
  const { incrementLoading, decrementLoading } = useLoadingContext()
  const {dispatch} = useAppContext()
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<LogCollection[]>([]);

  useEffect(() => {
    isLoading ? incrementLoading() : decrementLoading();
  }, [isLoading])

  const get = async (newQuery?: GetLogCollectionListReqQuery) => {
    if (newQuery) query = newQuery;

    let resData: LogCollection[] | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiGetLogCollectionList(query);

      setData(res.json.data);
      dispatch({
        type: 'GET',
        payload: {
          type: 'logCollections',
          data: res.json.data
        }
      });
      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  return {
    data,
    isLoading,
    get,
  };
};

export default useLogCollectionList;
